module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_4-4ce076cc848ed1645efd96ebbb0a6359.jpg";